import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
} from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { TFileUploadResponse } from './types';

export const mapEventsProgress = <T>(
  obs$: Observable<HttpEvent<T>>,
): Observable<TFileUploadResponse<T>> =>
  obs$.pipe(
    map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          return {
            done: false,
            pending: true,
            progress: event.total
              ? Math.round((event.loaded / event.total) * 100)
              : 0,
          };
        case HttpEventType.Response:
          return {
            done: true,
            pending: false,
            data: event.body,
          };
        default:
          return {
            done: false,
            pending: true,
          };
      }
    }),
    catchError((errorResponse: HttpErrorResponse) =>
      of({
        done: true,
        pending: false,
        error: errorResponse.error.message,
      }),
    ),
  );
